import { useEffect, useState } from 'react'
import { mailAPI } from '../services/api'

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function defaultSubject(sale) {
  const ref = sale?.reference || `SALE-${sale?.id || 'X'}`
  return `Devis/Facture ${ref} \u2014 ${sale?.client || ''}`.trim()
}

export function defaultBody(sale, lang) {
  const ref = sale?.reference || `SALE-${sale?.id || 'X'}`
  if (lang === 'en') {
    return `Hello,\n\nPlease find attached quote/invoice ${ref}.\n\nBest regards,\nGroupe Ouambo`
  }
  return `Bonjour,\n\nVeuillez trouver ci-joint le devis/facture ${ref}.\n\nCordialement,\nGroupe Ouambo`
}

export function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000))
  }
  return btoa(binary)
}

export function SendQuotePanel({ sale, form, lang, t, buildPdf, invoiceOf, busy }) {
  const [mailBusy, setMailBusy] = useState(false)
  const [msg, setMsg] = useState('')
  const [mail, setMail] = useState({
    to: '',
    replyTo: 'info@groupeouambo.com',
    subject: defaultSubject(sale),
    body: defaultBody(sale, lang),
  })
  const setM = (key) => (e) => setMail((p) => ({ ...p, [key]: e.target.value }))
  useEffect(() => {
    setMsg('')
    setMail({
      to: '',
      replyTo: 'info@groupeouambo.com',
      subject: defaultSubject(sale),
      body: defaultBody(sale, lang),
    })
  }, [sale, lang])

  const resolveAttachment = async () => {
    const merged = { ...sale, ...form }
    const url = invoiceOf(merged)
    if (url) {
      try {
        const r = await fetch(url)
        if (r.ok) {
          const buf = await r.arrayBuffer()
          let name = url.split('/').pop()?.split('?')[0] || 'invoice.pdf'
          if (!/\.pdf$/i.test(name)) name = `${name}.pdf`
          return { filename: name, base64: arrayBufferToBase64(buf) }
        }
      } catch (_) {}
    }
    return buildPdf(merged, lang)
  }

  const handleSendQuote = async () => {
    const to = mail.to.trim()
    if (!EMAIL_RE.test(to)) { setMsg(`${t.error}: ${t.invalidEmail}`); return }
    setMailBusy(true); setMsg('')
    try {
      const merged = { ...sale, ...form }
      const { filename, base64 } = await resolveAttachment()
      await mailAPI.send({
        to,
        replyTo: mail.replyTo.trim() || 'info@groupeouambo.com',
        subject: mail.subject.trim() || defaultSubject(merged),
        text: mail.body.trim() || defaultBody(merged, lang),
        attachmentFilename: filename,
        attachmentContentType: 'application/pdf',
        attachmentBase64: base64,
      })
      setMsg(t.sentOk)
    } catch (err) {
      setMsg(`${t.error}: ${err.message}`)
    } finally {
      setMailBusy(false)
    }
  }

  return (
    <div className="dash-form" style={{ marginTop: 16, gap: 10, borderTop: '1px solid #e5e7eb', paddingTop: 12 }}>
      <strong style={{ fontSize: 14 }}>{t.sendSection}</strong>
      <label>{t.toEmail}<input type="email" value={mail.to} onChange={setM('to')} placeholder="client@example.com" required /></label>
      <label>{t.replyTo}<input type="email" value={mail.replyTo} onChange={setM('replyTo')} /></label>
      <label>{t.subject}<input value={mail.subject} onChange={setM('subject')} /></label>
      <label>{t.body}<textarea rows={4} value={mail.body} onChange={setM('body')} /></label>
      <button type="button" className="dash-btn primary" disabled={mailBusy || busy} onClick={handleSendQuote} style={{ width: 'fit-content' }}>
        {mailBusy ? t.sending : `\uD83D\uDCE7 ${t.sendQuote}`}
      </button>
      {msg && <p className="dash-status-msg" style={{ marginTop: 10 }}>{msg}</p>}
    </div>
  )
}
